import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleText6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleText6"><Path fillRule="evenodd" clipRule="evenodd" d="M2 8.75C2 5.57436 4.57436 3 7.75 3H16.25C19.4256 3 22 5.57436 22 8.75V15.25C22 18.4256 19.4256 21 16.25 21H2V8.75ZM8 9V10.5H16V9H8ZM8 13.5V15H13V13.5H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleText6;
